"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@remirror/core");
const react_1 = tslib_1.__importStar(require("react"));
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const utils_1 = require("../../../../utils");
const react_if_1 = require("react-if");
const hooks_1 = require("../../../../hooks");
exports.AdminRoleChangerIcon = ({ adminRole, }) => {
    return (react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: adminRole === 'app'
            ? 'appAdminsOnly'
            : adminRole === 'workspace'
                ? 'workspaceAdminsOnly'
                : 'unlock', className: adminRole ? 'text-danger' : 'text-dark' }));
};
// app -> false -> workspace
const getNextRole = (adminRole, adminRoles) => {
    if (!adminRoles) {
        return false;
    }
    if (adminRole === 'app') {
        return false;
    }
    else if (adminRole === 'workspace') {
        return adminRoles.includes('app') ? 'app' : false;
    }
    else if (adminRole === false) {
        return adminRoles.includes('workspace')
            ? 'workspace'
            : adminRoles.includes('app')
                ? 'app'
                : false;
    }
    return false;
};
exports.AdminRoleChanger = () => {
    const [hasConfirmed, toggleHasConfirmed] = react_use_1.useToggle(false);
    const { adminRole, adminRoles, currentWorkspace } = hooks_1.useOsmosysContext();
    const { switchAdminRole } = hooks_1.useOsmosysUpdate();
    // Listen for window events `toggleOsmosysAdminRole` for automated switching
    react_1.useEffect(() => {
        const handler = () => {
            switchAdminRole(getNextRole(adminRole, adminRoles));
        };
        window.addEventListener('toggleOsmosysAdminRole', handler);
        return () => {
            window.removeEventListener('toggleOsmosysAdminRole', handler);
        };
    }, []);
    const nextRole = react_1.useMemo(() => getNextRole(adminRole, adminRoles), [
        adminRole,
        adminRoles,
    ]);
    const displayAdminRole = react_1.useMemo(() => core_1.capitalize(adminRole ? `${adminRole} admin` : 'User'), [adminRole]);
    return (react_1.default.createElement(AdminRoleChangerInnner, { displayAdminRole: displayAdminRole, nextRole: nextRole, adminRoles: adminRoles, adminRole: adminRole, hasConfirmed: hasConfirmed, currentWorkspace: currentWorkspace, toggleHasConfirmed: toggleHasConfirmed, switchAdminRole: switchAdminRole }));
};
const AdminRoleChangerInnner = ({ displayAdminRole, adminRoles, adminRole, nextRole, currentWorkspace, hasConfirmed, toggleHasConfirmed, switchAdminRole, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_if_1.When, { condition: !!(adminRoles && adminRoles.length > 0) }, () => (react_1.default.createElement(reactstrap_1.NavItem, null,
            react_1.default.createElement(react_2.OsmosysTooltip, { label: `Use as ${nextRole === 'app'
                    ? 'an app admin'
                    : nextRole === 'workspace'
                        ? `a workspace admin for ${currentWorkspace.name}`
                        : 'regular user'} (Using as ${adminRole === 'app'
                    ? 'an app admin'
                    : adminRole === 'workspace'
                        ? `a workspace admin for ${currentWorkspace.name}`
                        : 'regular user'})` },
                react_1.default.createElement(reactstrap_1.NavLink, { href: "#", "data-cy": "admin-role-changer", "data-current-admin-role": adminRole, "data-next-admin-role": nextRole, onClick: e => {
                        e.preventDefault();
                        if (!hasConfirmed) {
                            const confirmed = confirm(`Warning: You may lose unsaved changes by switching your admin role to ${nextRole}. Are you sure you want to continue?`);
                            if (!confirmed) {
                                return;
                            }
                            toggleHasConfirmed(true);
                        }
                        switchAdminRole(nextRole);
                    } },
                    react_1.default.createElement(exports.AdminRoleChangerIcon, { adminRole: adminRole }),
                    react_1.default.createElement("span", { className: utils_1.classnames('d-none d-md-inline ml-2', adminRole ? 'text-danger' : 'text-success') }, displayAdminRole))))))));
};
//# sourceMappingURL=AdminRoleChanger.js.map